import InfoList from '../../views/info/List.vue';

// お知らせ一覧
window.Vue.component('info-list', InfoList);
